import { render } from "./App.vue?vue&type=template&id=440487ac"
const script = {}

import exportComponent from "/home/scrptusr/an-script-manager/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__